<template>
    <component :is="`h${level}`" class="title">
        <span class="title-prefix" :class="`title-prefix-${color}`">
            <span class="color" />
            <span class="pulse" />
            &nbsp;
        </span>
        <slot></slot>
    </component>
</template>

<script lang="ts" setup>
withDefaults(
    defineProps<{
        level?: number;
        color?: "primary" | "secondary" | "tertiary";
    }>(),
    {
        level: 2,
        color: "primary",
    }
);

// Get a random delay for each title instance.
const animationDelay = Math.random() * 2 + "s";
</script>

<style lang="scss" scoped>
@keyframes pulse {
    from {
        transform: scale3d(1, 1, 1);
        opacity: 0.75;
    }
    50% {
        transform: scale3d(2.6, 1.3, 1);
        opacity: 0;
    }
    to {
        opacity: 0;
    }
}

.title {
    .title-prefix {
        height: 100%;
        width: 0.25em;
        margin-right: 0.5em;
        margin-left: -0.75em;
        white-space: pre;
        position: relative;
        transform: rotate(15deg);

        .color {
            position: absolute;
            inset: 0;
            z-index: 0;
        }

        .pulse {
            inset: 0;
            position: absolute;
            background: var(--stekz-primary-background);
            z-index: -1;
            animation: pulse 2s linear infinite;
            animation-delay: v-bind(animationDelay);
        }
    }

    .title-prefix-primary .color {
        background-color: var(--stekz-primary-background);
    }
    .title-prefix-secondary .color {
        background-color: var(--stekz-secondary-background);
    }
    .title-prefix-tertiary .color {
        background-color: var(--stekz-tertiary-background);
    }
    > * {
        display: inline-block;
    }
}
</style>
